import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "ef-formTemplate" }
const _hoisted_2 = {
  key: 0,
  class: "ef-formTemplate__title"
}
const _hoisted_3 = {
  key: 1,
  class: "ef-formTemplate__inputs"
}
const _hoisted_4 = {
  key: 0,
  class: "ef-formTemplate__readOnly"
}
const _hoisted_5 = {
  key: 0,
  class: "ef-formTemplate__checkbox"
}
const _hoisted_6 = { class: "ef-formTemplate__checkboxTitle" }
const _hoisted_7 = {
  key: 1,
  class: "ef-formTemplate__radio"
}
const _hoisted_8 = { class: "ef-formTemplate__radioTitle" }
const _hoisted_9 = {
  key: 2,
  class: "ef-formTemplate__select"
}
const _hoisted_10 = { class: "ef-formTemplate__fileUploader" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Télécharger un fichier")
const _hoisted_12 = { class: "ef-formTemplate__files" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file" }, null, -1)

import {ref} from "vue";
import InputType from '@/types/Input.ts';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import Checkbox from '@/components/Checkbox.vue';
import Radio from '@/components/Radio.vue';
import Select from '@/components/Select.vue';
import TextArea from '@/components/TextArea.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  inputs: { type: Array, default: () => [] },
  title: { type: String, default: '' },
  readOnly: { type: Boolean, default: false },
  formId: { type: String, default: '' }
},
  setup(__props) {

const props = __props



//DATA
const errorCount = ref(0);
const openUploadfile = ref (false);

const updateCheckbox = (args: any, choices: Array<any>, values: Array<any>) => {
  let item: InputType = {};
  choices.forEach((choice: any) => {
    if (choice.name === args.id.split('-')[1]) item = choice;
  });
  let index: number = values.indexOf(item);
  if (args.checked) {
    if (index < 0) {
      values.push(item.id);
    }
  } else {
    values.splice(index, 1);
  }
};

const updateError = (isError: boolean) => {
  isError ? errorCount.value++ : errorCount.value--;
};

const checkCondition = (slaveInput: any) => {
  if (slaveInput.condition === undefined) return true;
  else {
    let masterInput: any = props.inputs.find((input: any) => input.field === slaveInput.condition.field);
    if (masterInput.type === 'checkbox') {
      return masterInput.value.includes(slaveInput.condition.value);
    } else return masterInput.value === slaveInput.condition.value;
  }
};

const computedValue = (value: any) => {
  if (typeof value !== 'boolean') {
    return value;
  } else {
    if (value) return 'Oui';
    else return 'Non';
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    (__props.inputs.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.inputs, (input, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (__props.readOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createTextVNode(_toDisplayString(input.placeholder) + " : ", 1),
                    _createElementVNode("strong", null, _toDisplayString(computedValue(input.value)), 1)
                  ]))
                : (checkCondition(input))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (input.type === 'checkbox')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(input.placeholder), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.choices, (choice, cIndex) => {
                              return (_openBlock(), _createBlock(Checkbox, {
                                key: 'checkbox'+cIndex,
                                label: choice.name,
                                id: input.field + '-' + choice.name,
                                onChange: ($event: any) => (updateCheckbox($event, input.choices, input.value))
                              }, null, 8, ["label", "id", "onChange"]))
                            }), 128))
                          ]))
                        : (input.type === 'radio')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(input.placeholder), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.choices, (choice, cIndex) => {
                                return (_openBlock(), _createBlock(Radio, {
                                  key: cIndex,
                                  name: input.field + __props.title + index,
                                  label: choice.name,
                                  value: choice.id,
                                  checked: choice.id === input.value,
                                  onChange: ($event: any) => (input.value = choice.id)
                                }, null, 8, ["name", "label", "value", "checked", "onChange"]))
                              }), 128))
                            ]))
                          : (input.type === 'select')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(Select, {
                                  placeholder: input.placeholder,
                                  choices: input.choices,
                                  choiceSelected: input.value,
                                  helperMsg: input.helper,
                                  required: input.required,
                                  onChange: ($event: any) => (input.value = $event),
                                  "onUpdate:error": _cache[0] || (_cache[0] = ($event: any) => (updateError(errorCount.value, $event)))
                                }, null, 8, ["placeholder", "choices", "choiceSelected", "helperMsg", "required", "onChange"])
                              ]))
                            : (input.type === 'textarea')
                              ? (_openBlock(), _createBlock(TextArea, {
                                  key: 3,
                                  placeholder: input.placeholder,
                                  value: input.value,
                                  "onUpdate:modelValue": ($event: any) => (input.value = $event),
                                  rules: input.rules,
                                  "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => (updateError($event)))
                                }, null, 8, ["placeholder", "value", "onUpdate:modelValue", "rules"]))
                              : (input.type === 'uploadFile')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                    _createElementVNode("div", _hoisted_10, [
                                      _createElementVNode("div", null, _toDisplayString(input.placeholder), 1),
                                      _createVNode(Button, {
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (openUploadfile.value = true))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_11
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.value, (file, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "ef-formTemplate__file",
                                          key: index
                                        }, [
                                          _hoisted_13,
                                          _createTextVNode(_toDisplayString(file), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ], 64))
                                : (_openBlock(), _createBlock(Input, {
                                    key: 5,
                                    modelValue: input.value,
                                    "onUpdate:modelValue": ($event: any) => ((input.value) = $event),
                                    value: input.value,
                                    type: input.type,
                                    helperMsg: input.helper,
                                    placeholder: input.placeholder,
                                    rules: input.rules,
                                    "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => (updateError($event)))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "value", "type", "helperMsg", "placeholder", "rules"]))
                    ], 64))
                  : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", { errorCount: errorCount.value })
  ]))
}
}

})